import React from 'react'
import ReactDom from 'react-dom'
import { Radar, Doughnut } from 'react-chartjs'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import HSeparator from '../../img/commons/hseparator.png'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'

export default class DashboardCharts extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      riesgoIcc: 0,
      riesgoIm: 0,
      riesgoAcv: 0,
      tfg: 0,
      puntajeComplejidad: 0,
      RiesgoPromAñoComplic: 0,
      supervivenciaAlAño: 0,
      ICC: 'ICC',
      IAM: 'IAM',
      ANG: 'Angina / Isquemia',
      ACV: 'ACV',
      riesgoAnginaIsquemia: 0
    })
  }

  stateValue (data, dataRE) {
    if (dataRE === 'N/A') {
      return data + '%'
    } else {
      return dataRE + '%'
    }
  }
  stateName (data, dataRE) {
    if (dataRE !== 'N/A') {
      return ' con Evento Previo'
    } else {
      return ' sin Evento Previo'
    }
  }
  componentDidMount () {
    let identificacion = this.props.patient
    let endpoint = 'api/v1/diabetes/diabetes/'
    request
    .get(endpoint)
    .query({ id: identificacion })
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if (err) {
        console.log(err)
      } else {
        let diabetes = res.body
        this.setState({
          riesgoIcc: this.stateValue(diabetes.riesgoIcc, diabetes.riesgoReeventoIcc),
          riesgoIm: this.stateValue(diabetes.riesgoIm, diabetes.riesgoReeventoIm),
          riesgoAcv: this.stateValue(diabetes.riesgoAcv, diabetes.riesgoReeventoAcv),
          riesgoAnginaIsquemia: this.stateValue(diabetes.riesgoAnginaIsquemia, diabetes.riesgoReeventoAnginaIsquemia),
          tfg: diabetes.tfg + '%',
          puntajeComplejidad: diabetes.puntajeComplejidad,
          RiesgoPromAñoComplic: diabetes.RiesgoPromAñoComplic + '%',
          riesgoHospitalizacion: diabetes.riesgoHospitalizacion + '%',
          supervivenciaAlAño: diabetes.supervivenciaAlAño + '%',
          ICC: 'ICC' + this.stateName(diabetes.riesgoIcc, diabetes.riesgoReeventoIcc),
          IAM: 'IAM' + this.stateName(diabetes.riesgoIcc, diabetes.riesgoReeventoIm),
          ACV: 'ACV' + this.stateName(diabetes.riesgoIcc, diabetes.riesgoReeventoAcv),
          ANG: 'Angina / Isq.' + this.stateName(diabetes.riesgoIcc, diabetes.riesgoReeventoAnginaIsquemia)
        })
      }
    })
  }
  render () {
    var data1 = {
      labels: ['Riesgo subclínico', 'Vigor', 'METs', 'Balance afectivo', 'Satisfacción'],
      datasets: [
        {
          label: 'Calculo',
          fillColor: 'rgba(198, 31, 40, 0.4)',
          strokeColor: 'rgba(198, 31, 40, 0.8)',
          highlightFill: 'rgba(198, 31, 40, 0.5)',
          highlightStroke: 'rgba(198, 31, 40, 0.8)',
          data: this.props.data.chart1
        }
      ]
    }

    var data2 = {
      labels: ['Arterial', 'Metabólica', 'Cardiopulmonar', 'Bienestar', 'Vigor'],
      datasets: [
        {
          label: 'Calculo',
          fillColor: 'rgba(30, 124, 144, 0.4)',
          strokeColor: 'rgba(30, 124, 144, 0.8)',
          highlightFill: 'rgba(30, 124, 144, 0.5)',
          highlightStroke: 'rgba(30, 124, 144, 0.8)',
          data: this.props.data.chart2
        }
      ]
    }

    var data3 = [{
      value: this.props.data.fx_reserve.toFixed(1),
      color: 'rgba(30, 124, 144, 0.7)',
      label: 'Reserva funcional'
    }, {
      value: this.props.data.percent_lost_capacity.toFixed(1),
      color: 'rgba(198, 31, 40, 0.5)',
      label: 'Capacidad perdida'
    }]

    var chartOptions = {
      pointLabelFontSize: 12, scaleShowLabels: true,
      scaleStartValue: 0, scaleOverride: true,
      pointLabelFontColor: '#EFEFEF', scaleSteps: 5, scaleStepWidth: 2,
      scaleFontColor: '#EFEFEF', scaleLineColor: '#EFEFEF',
      angleLineColor: 'rgba(255,255,255,0.5)', responsive: true,
      scaleBackdropColor: 'rgba(255,255,255,0.75)'
    }

    var doughnutOptions = {
      segmentShowStroke: false, animateRotate: true,
      animateScale: false, percentageInnerCutout: 50,
      tooltipTemplate: '<%= value %>%'
    }

    var diabetico = this.props.data.patientData.diabetico
    return (
      <div className='chart-section'>
        <div className='container-slide'>
          <Tabs selectedIndex={1}>
            <TabList>
              <Tab>Indice de vitalidad</Tab>
              <Tab>Indice de capacidad funcional</Tab>
              <Tab>Reserva funcional</Tab>
              {(diabetico === true) ? <Tab>Diabético</Tab> : null}
            </TabList>
            <TabPanel>
              <div className='healt-squares'>
              {this.props.data.chart1 ?
                  <Radar data={data1} className='chart chart-radar' options={chartOptions} redraw />
                : null
              }
              </div>
            </TabPanel>
            <TabPanel>
              <div className='healt-squares'>
              {this.props.data.chart1 ?
                <Radar data={data2} className='chart chart-radar' options={chartOptions} redraw />
                : null
              }
              </div>
            </TabPanel>
            <TabPanel>
              <div className='healt-squares'>
              {this.props.data ?
                <Doughnut data={data3} className='chart chart-doughnut' height='260' width='520' options={doughnutOptions} redraw />
                : null }
              </div>
            </TabPanel>
            {
              (diabetico === true)
              ? <TabPanel>
                    <div className='healt-squares diab-center'>
                      <div className='diabetes-chart'>
                        <div className='diabetes-tag-col'>
                          <label className='dash-diabetes-data-label'>{this.state.IAM}</label>
                          <label className='dash-diabetes-data-label'>{this.state.ICC}</label>
                          <label className='dash-diabetes-data-label'>{this.state.ACV}</label>
                          <label className='dash-diabetes-data-label'>{this.state.ANG}</label>
                        </div>
                        <div className='graphic-column'>
                          <div className='diabetes-line-chart'>
                            <div className='diabetes-label-result' style={{width: this.state.riesgoIm}}>{this.state.riesgoIm}</div>
                          </div>
                          <div className='diabetes-line-chart'>
                            <div className='diabetes-label-result' style={{width: this.state.riesgoIcc}}>{this.state.riesgoIcc}</div>
                          </div>
                          <div className='diabetes-line-chart'>
                            <div className='diabetes-label-result' style={{width: this.state.riesgoAcv}}>{this.state.riesgoAcv}</div>
                          </div>
                          <div className='diabetes-line-chart'>
                            <div className='diabetes-label-result' style={{width: this.state.riesgoAnginaIsquemia}}>{this.state.riesgoAnginaIsquemia}</div>
                          </div>
                        </div>
                      </div>
                      <img className='dash-diabetes-separator' src={HSeparator}/>
                      <div className='severity-components'>
                        <div className='result-data-values-rcv results-avg'>
                          <div className='severity-data'>TFG</div>
                          <div className='severity-data'>(ml/min/tic2)</div>
                          <div className='severity-value'>{this.state.tfg}</div>
                        </div>
                        <div className='result-data-values-rcv results-avg'>
                          <div className='severity-data'>Riesgo prom/año de</div>
                          <div className='severity-data'>complicación</div>
                          <div className='severity-value'>{this.state.RiesgoPromAñoComplic}</div>
                        </div>
                        <div className='result-data-values-rcv results-avg'>
                          <div className='severity-data'>Riesgo hospitalización,</div>
                          <div className='severity-data'>evento CV y M</div>
                          <div className='severity-value'>{this.state.riesgoHospitalizacion}</div>
                        </div>
                      </div>
                      <div className='severity-components'>
                        <div className='result-data-values-rcv results-avg'>
                          <div className='severity-data'>Supervivencia</div>
                          <div className='severity-data'>al año</div>
                          <div className='severity-value'>{this.state.supervivenciaAlAño}</div>
                        </div>
                        <div className='result-data-values-rcv results-avg'>
                          <div className='severity-data'>Puntaje</div>
                          <div className='severity-data'>complejidad</div>
                          <div className='severity-value'>{this.state.puntajeComplejidad}</div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
              : null
            }
          </Tabs>
        </div>
      </div>
    )
  }
}

DashboardCharts.propTypes = {
  data: React.PropTypes.object,
  patient: React.PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardChartComponent.js